import { render, staticRenderFns } from "./NixiaAttachmentDownload.vue?vue&type=template&id=28b018fc&scoped=true&"
import script from "./NixiaAttachmentDownload.vue?vue&type=script&lang=js&"
export * from "./NixiaAttachmentDownload.vue?vue&type=script&lang=js&"
import style0 from "./NixiaAttachmentDownload.vue?vue&type=style&index=0&id=28b018fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b018fc",
  null
  
)

export default component.exports